import { useState } from "react";
import { tv } from "tailwind-variants";

import { Button, icons } from "@/ui";
import { Input, type InputProps } from "./input";

const passwordInputVariants = tv({
  slots: {
    icon: "size-4",
  },
  variants: {
    error: {
      true: {
        icon: "text-danger/70",
      },
    },
  },
});

const { icon } = passwordInputVariants();

type PasswordInputProps = {
  showDisplayPasswordButton?: boolean;
} & InputProps;

export const PasswordInput = ({ showDisplayPasswordButton, ...props }: PasswordInputProps) => {
  const [passwordVisible, setPasswordVisible] = useState(false);

  const Icon = passwordVisible ? icons.EyeIcon : icons.EyeSlashIcon;

  return (
    <Input
      right={
        showDisplayPasswordButton ? (
          <Button
            onClick={() => {
              return setPasswordVisible((v) => {
                return !v;
              });
            }}
            size="tight"
            variant="focus"
          >
            <Icon className={icon({ error: Boolean(props.error) })} />
          </Button>
        ) : null
      }
      type={passwordVisible ? "text" : "password"}
      {...props}
    />
  );
};
